import React, { useEffect, useState } from 'react'
import { useSelector } from "src/stateManagement/redux";
import './trendStyles.scss'
import { Box } from '@mui/material';
import Grid from "@mui/material/Grid2";
import { ModalAnalyst } from './components';


const carts = [
  { id: 1, image: "/assets/icons/bcp.svg", name: "PCP", method: ['BCP'] },
  { id: 2, image: "/assets/icons/well_whisper_blue.svg", name: "SRP", method: ['BM'] },
  { id: 3, image: "/assets/icons/gaslift.svg", name: "Gas Lift", method: ['Gas Lift'] },
  { id: 4, image: "/assets/icons/esp.svg", name: "ESP", method: ['ESP'] },
]

export const Trends = () => {

  const { method } = useSelector((state) => state.location);

  const [activeCart, setactiveCart] = useState<any>(undefined)
  

  const onClickCart = (cart: any) => {
    setactiveCart(cart)
  }

  const closeModalAnalyst = () => {
    setactiveCart(undefined)
  }


  return (
    <Box>
      {activeCart && (<ModalAnalyst activeCart={activeCart} close={closeModalAnalyst}/>)}
      <Grid className="trend-card-container">
        {carts.map((cart) => {
          if (!cart.method.includes(method)) return null

          return (
            <Grid key={cart.id} className="trend-card" onClick={() => onClickCart(cart)}>
              <img src={cart.image} alt={cart.name} className='trend-image' />
              <h4 className='trend-text '>{cart.name}</h4>
            </Grid>)
        })}
      </Grid>

    </Box>
  )
}
